import httpService from "app/services/httpService";
import config from "../../../src/config.json";

const apiUrl = config.apiUrl;

const getSystem = async (queryString) => {
  try {
    const url = `${apiUrl}/settings/system-service${
      queryString ? `?${queryString}` : ""
    }`;
    const data = await httpService.get(url);
    return data;
  } catch (error) {
    throw error;
  }
};

const addSystem = async (value) => {
  try {
    const { data } = await httpService.post(
      `${apiUrl}/settings/system-service`,
      value
    );
    return data;
  } catch (error) {
    console.log(error);
  }
};

const editSystem = async (value) => {
  try {
    const { data } = await httpService.post(
      `${apiUrl}/settings/system-service/edit`,
      value
    );
    return data;
  } catch (error) {
    console.log(error);
  }
};

const deleteSystem = async (id, value) => {
  try {
    const { data } = await httpService.post(
      `${apiUrl}/settings/system-service/delete?Id=${id}`,
      value
    );
    return data;
  } catch (error) {
    console.log(error);
  }
};
export { getSystem, addSystem, editSystem, deleteSystem };
